import React from 'react'
import data from '../data/Project.json';
const Project = () => {
    return (
        <div className='project'>
            <h2>Projects</h2>
            {data ?
                <div> {data.map((item, index) =>
                    <a href={item.projectWebsite} target='_blank'  rel="noreferrer" key={index}>
                    <div className='wrapper project flex flex-column md:gap-6 gap-5'>
                        <div className='image w-1/5'>
                            <img src={item.projectImage} alt='Ganesh Pataiya' className='projectIamge'></img>
                        </div>
                        <div className='projectDetails w-4/5'>
                            <div className='name flex items-center'>
                                {item.projectName}
                               
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="inline-block h-4 w-4 shrink-0 transition-transform group-hover/link:-translate-y-1 group-hover/link:translate-x-1 group-focus-visible/link:-translate-y-1 group-focus-visible/link:translate-x-1 motion-reduce:transition-none ml-1 translate-y-px" aria-hidden="true"><path fillRule="evenodd" d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z" clipRule="evenodd"></path></svg></div>
                           
                            <div className='description'>{item.description}</div>
                            <div className='tech'>
                                {
                                    item.technology.map((tech, index) => { return (<div className="tag" key={index}>{tech}</div>) })
                                }
                            </div></div>
                    </div>

                    </a>

                )}</div> : <div>
                    Comming soon !...</div>}

                  
        </div>
    );
};

export default Project;